import React from 'react';
import { Option } from '../../../elements/Select/Option';
import { Select } from '../../../elements/Select/Select';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { sortSelectOptions } from './CreatEditPageMembershipMatchingRuleFormUtils';
import { SelectParam } from '../../../types/SelectParam';

export type AreaPageTypeValue = 'institution' | 'orgunit' | 'topic' | 'task' | 'teamroom' | 'location' | 'process';

type AreaPageTypeSelectProps = {
  areaPageTypeParam: SelectParam<'areaPageType', { value: AreaPageTypeValue }>,
  onChange: React.ChangeEventHandler<HTMLSelectElement, HTMLSelectElement>,
  defaultValue?: AreaPageTypeValue | undefined,
};

export function AreaPageTypeSelect({
  areaPageTypeParam,
  onChange,
  defaultValue = areaPageTypeParam.value as AreaPageTypeValue,
}: AreaPageTypeSelectProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleSettingsForm');

  return (
    <Select
      label={t('inputs.areaPageType.label')}
      param={areaPageTypeParam}
      defaultValue={defaultValue}
      onChange={onChange}
    >
      {sortSelectOptions(areaPageTypeParam.options, key => t(`inputs.areaPageType.options.${key}` as any)).map(
        option => (
          <Option key={option.value} value={option.value}>
            {option.value ? t(`inputs.areaPageType.options.${option.value}` as any) : option.text}
          </Option>
        ),
      )}
    </Select>
  );
}
